import { useState } from 'react';
import Button from '@mui/material/Button'; 
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';  
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs'; 
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import Chip from '@mui/material/Chip';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { DataGrid, GridToolbarContainer, GridToolbarFilterButton } from '@mui/x-data-grid'; 
import { DataGridPro } from '@mui/x-data-grid-pro';
import Tooltip from '@mui/material/Tooltip';
import Stack from '@mui/material/Stack';
import './emulatorPage.css';
import { format } from 'date-fns'; 
import ClickAwayListener from '@mui/material/ClickAwayListener';


// import { Link } from "react-router-dom"; 
const renderDate = (date) => {
  if (!date) {
    return '';
  } 
  return format(new Date(date), 'dd/MM/yyyy');
}

const data = [
  {
    groupName: 'Chat Group 1',
    groupUID: '-12890371920873',
    lastCollectedDate: new Date(2020, 11, 20),
    emulator: "hunnycloud1",
    id: 2,
  },
  {
    groupName: 'sgCovid',
    groupUID: '-128903719202135',
    lastCollectedDate: new Date(2020, 11, 20),
    emulator: "hunnycloud2",    
    id: 1,
  },
  {
    groupName: 'Chat Group 2',
    groupUID: '128903719202135',
    lastCollectedDate: new Date(2020, 10, 14),
    emulator: "hunnycloud3",
    id: 3,
  },
  {
    groupName: 'Chat Group 3',
    groupUID: '128903719202135',
    lastCollectedDate: new Date(2017, 10, 29),
    emulator: "hunnycloud1",
    id: 4,
  },
  {
    groupName: 'Chat Group 1',
    groupUID: '128903719202135',
    lastCollectedDate: new Date(2020, 7, 21),
    emulator: "hunnycloud2",
    id: 5,
  }, 
  {
    groupName: 'Chat Group 1',
    groupUID: '128903719202135',
    lastCollectedDate: new Date(2020, 7, 21),
    emulator: "hunnycloud2",
    id: 6,
  }, 
  {
    groupName: 'Chat Group 1',
    groupUID: '128903719202135',
    lastCollectedDate: new Date(2020, 7, 21),
    emulator: "hunnycloud2",
    id: 7,
  },   
];
 
function CustomToolbar() {
  return (
    <GridToolbarContainer> 
      <GridToolbarFilterButton /> 
      <Box sx={{ flexGrow: 1 }} /> 
    </GridToolbarContainer>
  );
}   

function CustomTable(props) {
  const [copyUid, setCopyUid] = useState(false);
  const [copyName, setCopyName] = useState(false);
  const [open, setOpen] = useState(false);
 
  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  }; 
  
  const copyToClipboard = (value, type) => {
    global.navigator.clipboard.writeText(value);
    if (type === "uid") {
      setCopyUid(true);
      const timer = setTimeout(() => setCopyUid(false), 500);
      return () => clearTimeout(timer);
    } else {
      setOpen(true);
      console.log("test")
      // const timer = setTimeout(() => setCopyName(false), 500);
      // return () => clearTimeout(timer);
    } 
  }  
  
  const data_columns = [ 
    { 
      field: 'groupName', 
      headerName: 'Group Name', 
      width: 150, 
      flex: 1,
      renderCell: (params) => (
        <div>
                  <ClickAwayListener onClickAway={handleTooltipClose}>
          <div>
            <Tooltip
              onClose={handleTooltipClose}
              open={open}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title="Copied!"
              slotProps={{
                popper: {
                  disablePortal: true,
                },
              }}
            >
              <Typography className="copy-id" onClick={handleTooltipOpen}>{params.value}</Typography>
            </Tooltip>
          </div> 
        </ClickAwayListener>  
        </div>

      )
    },    
    { 
      field: 'groupUID', 
      headerName: 'Group UID', 
      width: 150, 
      flex: 1,
      renderCell: (params) => ( 
        <Tooltip title={copyUid ? "Copied!" : ""} leaveDelay={300}>
          <Typography className="copy-id" onClick={() => copyToClipboard(params.value, "uid")}>{params.value}</Typography>
        </Tooltip>
      )
    },
    { 
      field: 'lastCollectedDate',
      headerName: 'Last Collected Date',
      type: 'date',
      width: 150,
      flex: 1,
      renderCell: (params) => ( 
        <Typography>{renderDate(params.value)}</Typography>
      )    
    },
    { 
      field: 'emulator', 
      headerName: 'Emulator', 
      width: 150, 
      flex: 1,
      renderCell: (params) => ( 
        <Typography>{params.value}</Typography>
      )
    },
  ];    
  
  return (
    <div style={{ height: '100%',  paddingBottom: "5rem" }} >
      <DataGridPro 
        pagination 
        rows={props.data}
        columns={data_columns} 
        disableSelectionOnClick 
        disableRowSelectionOnClick 
        disableColumnResize 
        disableColumnMenu
        slots={{ toolbar: CustomToolbar }}
        sx={{
            "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                outline: "none !important", 
            },  
            "&.MuiDataGrid-root .MuiDataGrid-cell": {
                whiteSpace: "normal !important",
                wordWrap: "break-word !important", 
                display: "flex !important",
                alignItems: "center !important"  
            },
            ".MuiButton-root": {
                color: "#605958"
            },
            "& .MuiDataGrid-row:hover": {
                backgroundColor: "rgba(218,218,218,0)", 
            }
        }} 
      />
    </div>  
  )  
}

export default function GroupPage(props) {   
    const [value, setValue] = useState('telegram'); 
    const handleChange = (event, newValue) => {
        setValue(newValue);
    }; 
  
    return (
        <div>
            <h1 className='header'>
                Group Info
            </h1>  
            <Box sx={{ marginLeft: '10%', marginRight: "10%" }}>
                <TabContext value={value}>
                    <Tabs
                        value={value}
                        onChange={handleChange} 
                        textColor="inherit"
                        indicatorColor="inherit"
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: "#FFB100", 
                            }
                        }} 
                    >
                        <Tab sx={{ "&.Mui-selected": { color: "#FFB100" }}} value="telegram" label="Telegram" />
                        <Tab sx={{ "&.Mui-selected": { color: "#FFB100" }}} value="whatsapp" label="WhatsApp" />
                        <Tab sx={{ "&.Mui-selected": { color: "#FFB100" }}} value="wechat" label="WeChat" /> 
                    </Tabs>                
                    <TabPanel value="telegram"><CustomTable data={data}/></TabPanel>
                    <TabPanel value="whatsapp"><CustomTable data={data}/></TabPanel>
                    <TabPanel value="wechat"><CustomTable data={data}/></TabPanel>
                </TabContext>                   
            </Box>
        </div>
    );
}      